import { 
  Container, 
  Stack, 
  Typography, 
  Button, 
  Card, 
  TableContainer, 
  Table, 
  TableBody, 
  TableRow, 
  TableCell, 
  IconButton, 
  TablePagination,
  Avatar,
  Divider,
  Fade,
  Zoom,
  Paper,
  Chip,
  Tooltip,
  Box,
  Grid
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Iconify from '../../../layouts/Iconify';
import Scrollbar from '../../../layouts/Scrollbar';
import { UserListHead, UserListToolbarcustom, UserMoreMenu } from '../../../layouts/user';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MiscSkeleton from '../../../layouts/user/MiscSkeleton';
import { GetAll, apiURL } from '../../../utils/apiCalls';
import { filter } from 'lodash';
import EditIcon from '@mui/icons-material/Edit';
import Label from '../../../layouts/Label';
import { capitalCase } from 'change-case';
import SearchNotFound from '../../../layouts/SearchNotFound';
import { 
  Payment, 
  FilterList, 
  Visibility,
  Category,
  PhotoLibrary,
  Business,
  Image,
  AttachMoney,
  TrendingUp,
  AccountBalance
} from '@mui/icons-material';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'no', label: 'SNo.', align: 'left' },
    { id: 'name', label: 'Payment Id', align: 'left' },
    { id: 'name', label: 'Project Name', align: 'left' },
    { id: 'place', label: 'Plot Number', align: 'left' },
    { id: 'type', label: 'Plot Area', align: 'left' },
    { id: 'type', label: 'Total Amount (₹)', align: 'left' },
    { id: 'type', label: 'Amount Paid (₹)', align: 'left' },
    { id: 'type', label: 'status', align: 'left' },
  ];
 
  // ----------------------------------------------------------------------
  
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function applySortFilter(array, comparator, query, plotNumber, createdDate) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
  
    let filteredArray = stabilizedThis.map((el) => el[0]);
  console.log(filteredArray,"ldkmf")
    // Apply the Project Name filter
    console.log(query,"query")
    if (query) {
      filteredArray = filter(filteredArray, (_user) =>
        JSON.stringify(_user.project_details['name']).toLowerCase().trim().indexOf(query.toLowerCase().trim()) !== -1
      );
    }
    console.log(plotNumber,"plotNumber")
    // Apply the Plot Number filter
    if (plotNumber) {
      filteredArray = filter(filteredArray, (_user) =>
        JSON.stringify(_user.plot_details['plot_id']).toLowerCase().trim().indexOf(plotNumber.toLowerCase().trim()) !== -1
      );
    }
    console.log(createdDate,"createdDate")
    // Apply the Created Date filter
    if (createdDate) {
      filteredArray = filter(filteredArray, (_user) =>
        _user.created_date && _user.created_date.indexOf(createdDate) !== -1
      );
    }
  
    return filteredArray;
  }
  

const PaymentDetails = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState();
    const [filterName, setFilterName] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterPlotNumber, setFilterPlotNumber] = useState('');
const [filterCreatedDate, setFilterCreatedDate] = useState('');

  
    async function GetList () {
      setLoading(true);
        const response = await GetAll(apiURL + '/api/v1/payments/get_payment_details');
        
        if (response) {
               console.log(response,"responseresponse")
          if (response.data.status) {       
          setLoading(false);
          setList(response.data.data)
          }
          else {
          setLoading(false);
          toast.error(response.data.message)
            setList([])
          }
        }
        else {
          setLoading(false);
        }
  };
  
    useEffect(()=> {
      GetList();    
    },[])
  
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = list.map((n) => n.exporter_company_Name);
        setSelected(newSelecteds);
        return;
      }
      setSelected([]);
    };
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const handleFilterByName = (event) => {
      setFilterName(event.target.value);
    };
  
    const basedoncolor = (value) => {
      switch (value) {
        case 'SUCCESS':
          return 'green'; // You can replace this with your desired color
        case 'FAILED':
          return 'red';
        case 'PROCESSING':
          return 'orange';
        case 'CANCELLED':
          return 'red';
        default:
          return 'black'; // Default color in case no match is found
      }
    };
    
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - list?.length) : 0;
  
    const filteredUsers = applySortFilter(list, getComparator(order, orderBy), filterName,filterPlotNumber,filterCreatedDate);
  
    const isUserNotFound = filteredUsers.length === 0;
    
    const handleClickEdit = (e, id) => {
      // e.preventDefault();
      navigate(`/dashboard/customerofferimages/${id}`)
  };

    return (
        <Container sx={{m:0, width:'100%', maxWidth:'100%'}} maxWidth={false}>
        <Fade in timeout={800}>
          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
              <Avatar sx={{ 
                bgcolor: '#1976d2', 
                width: 48, 
                height: 48,
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
              }}>
                <Payment sx={{ fontSize: 24, color: 'white' }} />
              </Avatar>
              <Box>
            <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
              Payment Details
            </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Track and manage all payment transactions
                </Typography>
              </Box>
            </Stack>
            <Divider sx={{ my: 2 }} />
          </Box>
        </Fade>

        {/* Main Content */}
        <Zoom in timeout={1000}>
          <Card elevation={4} sx={{ borderRadius: 3, overflow: 'hidden' }}>
            <Box sx={{ p: 3, background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <FilterList sx={{ color: '#1976d2', fontSize: 28 }} />
                <Typography variant="h6" fontWeight="600" color="text.primary">
                  Payment Records
          </Typography>
                <Chip
                  label={`${filteredUsers?.length || 0} Payments`}
                  sx={{
                    background: '#1976d2',
                    color: 'white',
                    fontWeight: 600,
                    ml: 'auto'
                  }}
                />
        </Stack>
            </Box>

        <UserListToolbarcustom
  placeholder="Search by Project Name"
  numSelected={selected.length}
  filterName={filterName}
  onFilterName={handleFilterByName}
  filterPlotNumber={filterPlotNumber}
  onFilterPlotNumber={(e) => setFilterPlotNumber(e.target.value)}
  filterCreatedDate={filterCreatedDate}
  onFilterCreatedDate={(e) => setFilterCreatedDate(e.target.value)}
/>

            <TableContainer sx={{ overflowX: 'auto' }}>
              <Table stickyHeader>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={list?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  isCheckbox={false}
                />
                        <TableBody>
                            {filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    return (
                      <TableRow 
                        hover 
                        key={row.id} 
                        sx={{
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 8px rgba(25, 118, 210, 0.1)'
                          }
                        }}
                      >
                        <TableCell component="th" scope="row" align="left">
                          <Chip
                            label={index + 1}
                            size="small"
                            sx={{
                              background: '#1976d2',
                              color: 'white',
                              fontWeight: 600,
                              minWidth: 32
                            }}
                          />
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Payment sx={{ color: '#1976d2', fontSize: 16 }} />
                            <Typography 
                              variant="body2" 
                              sx={{ 
                                color: '#1976d2',
                                fontWeight: 600,
                                fontFamily: 'monospace'
                              }}
                            >
                              {row.razorpay_payment_id || '-'}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Business sx={{ color: '#1976d2', fontSize: 16 }} />
                            <Typography variant="body2" fontWeight="500">
                              {row?.project_details?.name}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Image sx={{ color: '#1976d2', fontSize: 16 }} />
                            <Typography variant="body2" fontWeight="500">
                              {row?.plot_details?.plot_id}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="body2" fontWeight="500">
                            {row?.plot_details?.plot_area}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <AttachMoney sx={{ color: '#4caf50', fontSize: 16 }} />
                            <Typography variant="body2" fontWeight="600" color="#4caf50">
                              ₹{(row?.plot_details?.plot_area && row?.project_details?.price) ? (row?.plot_details?.plot_area * row?.project_details?.price).toFixed(2) : '-'}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <AccountBalance sx={{ color: '#ff9800', fontSize: 16 }} />
                            <Typography variant="body2" fontWeight="600" color="#ff9800">
                              ₹{row.pay_amount || '-'}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Chip
                            label={row.status || '-'}
                            size="small"
                            sx={{
                              background: basedoncolor(row.status) === 'green' ? '#4caf50' : 
                                         basedoncolor(row.status) === 'red' ? '#f44336' : 
                                         basedoncolor(row.status) === 'orange' ? '#ff9800' : '#9e9e9e',
                              color: 'white',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              fontSize: '0.75rem'
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={8} />
                    </TableRow>
                  )}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    {loading ? <MiscSkeleton record={{number: 7}}/> :
                    <TableRow>
                        <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                          {list?.length <= 0 ? 
                            <Typography gutterBottom align="center" variant="subtitle1">No payments found</Typography> :
                            <SearchNotFound searchQuery={filterName} />
                          }
                      </TableCell>
                      </TableRow>
                    }
                  </TableBody> 
                )}
              </Table>
            </TableContainer>

            <Box sx={{ 
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              borderTop: '1px solid rgba(0,0,0,0.1)'
            }}>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={filteredUsers?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  '& .MuiTablePagination-toolbar': {
                    background: 'transparent'
                  }
                }}
          />
            </Box>
        </Card>
        </Zoom>

        {/* Professional Stats Footer */}
        <Fade in timeout={1400}>
          <Paper
            elevation={2}
            sx={{
              mt: 4,
              p: 3,
              borderRadius: 3,
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ background: '#1976d2' }}>
                    <Payment sx={{ color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="600" color="text.primary">
                      Total Payments
                    </Typography>
                    <Typography variant="h4" fontWeight="700" color="#1976d2">
                      {filteredUsers?.length || 0}
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} md={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ background: '#4caf50' }}>
                    <TrendingUp sx={{ color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="600" color="text.primary">
                      Success Rate
                    </Typography>
                    <Typography variant="h4" fontWeight="700" color="#4caf50">
                      {filteredUsers?.filter(p => p.status === 'SUCCESS').length || 0}
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} md={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ background: '#ff9800' }}>
                    <AttachMoney sx={{ color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="600" color="text.primary">
                      Total Amount
                    </Typography>
                    <Typography variant="h4" fontWeight="700" color="#ff9800">
                      ₹{filteredUsers?.reduce((sum, p) => sum + (parseFloat(p.pay_amount) || 0), 0).toFixed(2)}
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Fade>
      </Container>
    )
}

export default PaymentDetails;